module.exports = __webpack_public_path__ + "static/media/export.cbaf7d4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/export.svg
// module id = 2438
// module chunks = 0